/**
 * 純粹讀 claim 的小工具。
 *
 * 刻意跟 `oidc.ts` 分開：`oidc.ts` 會 `import { UserManager }`（執行期依賴 oidc-client-ts，
 * 約 100KB），這裡只 `import type`（型別在編譯後會被抹掉）。
 * 這樣元件可以自由使用這些函式，而 oidc-client-ts 仍然只在使用者真的按下登入時才被載入 ——
 * 對一個「完全公開、大多數訪客不會登入」的入口站來說，這是對的取捨。
 */

import type { User } from 'oidc-client-ts';

/** Keycloak 的 realm role 放在 `realm_access.roles`（C03 §3 的 protocol mapper）。 */
export function realmRoles(user: User | null): string[] {
  const profile = user?.profile as unknown as { realm_access?: { roles?: unknown } } | undefined;
  const roles = profile?.realm_access?.roles;
  return Array.isArray(roles) ? roles.filter((r): r is string => typeof r === 'string') : [];
}

/** C03 §6：Email 驗證雙重把關 —— 後端每次驗 token 也會再檢查一次。 */
export function emailVerified(user: User | null): boolean {
  return user?.profile?.email_verified === true;
}

export function displayName(user: User | null): string {
  const p = user?.profile;
  return (
    (p?.name as string | undefined) ??
    (p?.preferred_username as string | undefined) ??
    (p?.email as string | undefined) ??
    ''
  );
}
